import {
  DEFAULT_MAP_STYLE,
  POLYGONS_DEFAULT_FILL_COLOR,
  POLYGONS_DEFAULT_STROKE_COLOR,
} from "@/providers/maps/constants";
import { getMapVisualThemeByStyle } from "@/providers/maps/map-visual-theme.config";

import { coerceSchoolTypesArray } from "./school-types-csv";

const defaultMapVisualTheme = getMapVisualThemeByStyle(DEFAULT_MAP_STYLE);

export interface BoundaryPolygonPreviewColors {
  fillColor?: string;
  strokeColor?: string;
  fillOpacity?: number;
  strokeOpacity?: number;
  strokeWidth?: number;
}

export interface BoundaryPreviewColorParams {
  schoolId?: string | null;
  schoolInternalId?: string | null;
  schoolName?: string | null;
  color?: string | null;
  schoolTypes?: readonly string[] | null;
  types?: string | null;
}

function isTypesPropertyEmpty(types: unknown): boolean {
  return coerceSchoolTypesArray(types).length === 0;
}

export function isPreviewBoundaryUnassignedForColor(
  params: BoundaryPreviewColorParams,
): boolean {
  if (params.schoolId?.trim()) {
    return false;
  }

  if (params.schoolInternalId?.trim() || params.schoolName?.trim()) {
    return false;
  }

  if (params.schoolTypes != null) {
    return params.schoolTypes.length === 0;
  }

  if (params.types !== undefined && params.types !== null) {
    return isTypesPropertyEmpty(params.types);
  }

  return true;
}

const defaultPreviewColors = (): BoundaryPolygonPreviewColors => ({
  fillColor: POLYGONS_DEFAULT_FILL_COLOR,
  strokeColor: POLYGONS_DEFAULT_STROKE_COLOR,
  fillOpacity: defaultMapVisualTheme.polygonFillOpacity,
  strokeOpacity: defaultMapVisualTheme.polygonLineOpacity,
});

export function getBoundaryPolygonPreviewColors(
  params: BoundaryPreviewColorParams,
): BoundaryPolygonPreviewColors {
  // Explicit color wins (map-level / colored boundaries often have no school).
  const trimmedColor = params.color?.trim();

  if (trimmedColor) {
    return {
      fillColor: trimmedColor,
      strokeColor: trimmedColor,
      fillOpacity: defaultMapVisualTheme.polygonFillOpacity,
      strokeOpacity: defaultMapVisualTheme.polygonLineOpacity,
    };
  }

  return defaultPreviewColors();
}

export function resolvePreviewBoundaryDisplayColor(
  params: BoundaryPreviewColorParams,
): string {
  const trimmedColor = params.color?.trim();
  if (trimmedColor) {
    return trimmedColor;
  }

  return POLYGONS_DEFAULT_FILL_COLOR;
}
